import api from '../utils/api';

export const fetchWeeklyComparison = async (stream = '') => {
  // CHANGED: Added '-revenue' to the path to match backend routes/index.js
  const response = await api.get('/weekly-revenue/comparison', {
    params: { stream }
  });
  return response.data;
};